import {
  Button,
  Checkbox,
  HStack,
  Input,
  Select,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useState } from "react";
import { getHeadersForRequest } from "../utils/functions";
import { PacketSizesValues, ProductsValues, taxRates } from "../utils/strings";
import useCustomTranslation from "../hooks/useCustomTranslation";
import { NumericData } from "qrcode";
import Cookies from "js-cookie";

type AddPresetPriceCardProps = {
  id?: number;
  product?: string;
  size?: string;
  price?: string;
  customerId: number;
  isVoid?: boolean;
  isEdit?: boolean;
  onSuccess?: () => void;
};

export const AddPresetPrice: React.FC<AddPresetPriceCardProps> = ({
  id,
  product,
  size,
  price,
  customerId,
  isVoid,
  isEdit,
  onSuccess
}) => {
  const [id1, setid] = useState<number>(id || 0);
  const [product1, setproduct] = useState<string>(product || "");
  const [size1, setsize] = useState<string>(size || "");
  const [price1, setprice] = useState<string>(price || "");
  const [customerId1, setcustomerId] = useState<number>(customerId || 0);
  const [isVoid1, setisVoid] = useState<boolean>(isVoid || false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const toast = useToast();
  const { t, changeLanguage } = useCustomTranslation();

  const handleEdit = async () => {
    setIsLoading(true);
    if (product1.trim() === "") {
      toast({
        title: "Name cannot be empty!",
        duration: 3000,
        status: "error",
      });
      setIsLoading(false);
      return;
    }
    if (size1.trim() === "") {
      toast({
        title: "Name cannot be empty!",
        duration: 3000,
        status: "error",
      });
      setIsLoading(false);
      return;
    }
    if (price1.trim() === "") {
      toast({
        title: "Name cannot be empty!",
        duration: 3000,
        status: "error",
      });
      setIsLoading(false);
      return;
    } 
    
    const headers = await getHeadersForRequest();

    console.log({id: id1,
          product: product1,
          size: size1,
          price: price1,
          customerId: customerId1,
          isVoid: isVoid1})
    
    await axios
      .post(
        `${process.env.REACT_APP_TEST_API_URL}/customers/updatePresetPrices`,
        {
          id: id1,
          product: product1,
          size: size1,
          price: price1,
          customerId: customerId1,
          isVoid: isVoid1,
        },
        { headers }
      )
      .then((response) => {
        toast({
          title: t("Details updated successfully"),
          duration: 3000,
          status: "success",
          // position: "bottom-right"
        });
        onSuccess?.();
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
        toast({
          title: t("Error updating"),
          duration: 3000,
          status: "error",
          // position: "bottom-right"
        });
      });
  };

  const handleSave = async () => {
    setIsLoading(true);
    if (product1.trim() === "") {
      toast({
        title: "Name cannot be empty!",
        duration: 3000,
        status: "error",
      });
      setIsLoading(false);
      return;
    }
    if (size1.trim() === "") {
      toast({
        title: "Name cannot be empty!",
        duration: 3000,
        status: "error",
      });
      setIsLoading(false);
      return;
    }
    if (price1.trim() === "") {
      toast({
        title: "Name cannot be empty!",
        duration: 3000,
        status: "error",
      });
      setIsLoading(false);
      return;
    } 
    
    const headers = await getHeadersForRequest();
    
    await axios
      .post(
        `${process.env.REACT_APP_TEST_API_URL}/customers/savePresetPrices`,
        {
          id: id1,
          product: product1,
          size: size1,
          price: price1,
          customerId: customerId1,
          isVoid: isVoid1,
        },
        { headers }
      )
      .then((response) => {
        toast({
          title: t("Details saved successfully"),
          duration: 3000,
          status: "success",
          // position: "bottom-right"
        });
        onSuccess?.();
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
        toast({
          title: t("Error saving"),
          duration: 3000,
          status: "error",
          // position: "bottom-right"
        });
      });
  };
  return (
    <Stack>
      <HStack flexWrap={"wrap"} display={"flex"} justifyContent={"center"}>
        <Stack>
          <HStack alignItems={"center"}>
            <Text fontSize="lg" fontFamily="">
              {t("Price")}
            </Text>
          </HStack>
          <Stack width={250}> 
            <Input
              borderWidth={3}
              fontSize="md"
              pl={5}
              defaultValue={price}
              backgroundColor="transparent"
              variant={"underlined"}
              onChange={(e) => {
                setprice(e.target.value);
              }}
              placeholder={t("EnterPrice")}
              inputMode="numeric"
            />            
          </Stack>
        </Stack>

        <Stack>
          <br/>
          <Text fontSize="lg" fontFamily="">
            {t("Product")}
          </Text>
          <Stack width={250}>
            <Select
              onChange={(e) => setproduct(e.target.value)}            
              borderWidth={3}
              defaultValue={product1}
            >
              {ProductsValues.map((value) => (
                <option value={value} key={value}>
                  {value.toString()}
                </option>
              ))}
            </Select>
          </Stack>
        </Stack>

        <Stack>
          <br/>
          <Text fontSize="lg" fontFamily="">
            {t("PacketSize")}
          </Text>
          <Stack width={250}>
            {Cookies.get("businessName") === "Keinth's Food" ? (
              <Select
                onChange={(e) => setsize(e.target.value)}              
                borderWidth={3}
                defaultValue={size1}
              >
                {PacketSizesValues.map((value) => (
                  <option value={value} key={value}>
                    {value.toString() + " gms"}
                  </option>
                ))}
              </Select>
            ) : (
              <Input
                borderWidth={3}
                fontSize="md"
                pl={5}
                value={size}
                backgroundColor="transparent"
                variant={"underlined"}
                onChange={(e) => setsize(e.target.value)}
                placeholder={t("Enter qty in gms")}
                inputMode="numeric"
                defaultValue={size1}
              />
            )}
          </Stack>
        </Stack>
      </HStack>
      <br />

      {isEdit && (
        <>
          <Checkbox
            defaultChecked={isVoid1}
            onChange={() => {
              setisVoid(!isVoid1);
            }}
          >
            {t("Disabled")}
          </Checkbox>

          <br />
        </>
      )}

      <Button variant={"solid"} colorScheme="blue" onClick={isEdit ? handleEdit : handleSave} isLoading={isLoading}>
        <Text>{isEdit ? t("Update") : t("Save")}</Text>
      </Button>
    </Stack>
  );
};
